import { load } from 'bot-detection-algo';

const fingerPrintInstance = (() => {
  const detectorInstance = botdPromise => {
    const instance = botdPromise
      .then(detector => detector)
      .catch(error => console.error(error));
    return instance;
  };
  const botdPromise = load();
  const detector = detectorInstance(botdPromise);
  return {
    getFPInstance: () => detector
  };
})();

export default fingerPrintInstance;
